export default {"src":"/_next/static/media/FCX.75a006f9.svg","height":18,"width":18};